import axios from "axios"
export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
        res_login:''
    }
    ,
    getters: {
        authenticated(state) {
            return (state.token && state.user!=null)
        },
        user(state) {
            return state.user
        },
        loginStatus(state){
            return state.res_login
        },
        login_token_cart(state){
            // console.log(state , 'login status');
            return state;
        }
    }
    ,
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER(state, data) {
            state.user = data;
        }
    },
    // watch: {
    //     $route (to, from) {
    //      console.log('watch ' , from , to);
    //     }
    //   },
    actions: {
        async mobile_verify({ dispatch , state }, credentials) {
            // let response = await axios.post('/login', credentials); // مندون ال await رح ينفذ الرسبونسف مندون م يستنى الطباعه
            // console.log('mobile verify auth');
               let response = await axios({ method: 'POST', url: '/api/users/login_phone_verify', data: {
                'phone':credentials.phone,
                'code':credentials.code
               }, validateStatus: () => true })
                state.res_login = response;
                // console.log(response.data.token , 'response auth')
            return dispatch('attempt', response.data.token);
        },
        async attempt({ commit, state }, token) {
            if (token) {
                commit('SET_TOKEN', token);
            }

            if (!state.token) {
                return;
            }
            try {
                 //console.log('my Token :' , token);
                 //if (token) { axios.defaults.headers.common['Authorization'] = 'Bearer ' + token; }
                 let response = axios.get('/front/get_info'); //1
                //  console.log('get User response :' , (await response).data);
                 commit('SET_USER', (await response).data); //2
                // console.log('set new data user removee', (await response).data.data);
            } 
            catch (e) {
                 commit('SET_TOKEN', null);
                 commit('SET_USER', null);
                console.log('catch')
            }
        }
        ,
        signOut({ commit }) {
            return axios.get('/front/logout').then(() => {
                commit('SET_TOKEN', null);
                commit('SET_USER', null);
            })
        }

    }
}